import { sensorUnits } from 'commons/src/constants';
import Co2Png from 'commons/src/img/sensorIcons/sensorPng/sensor-co2.png';
import HumidityPng from 'commons/src/img/sensorIcons/sensorPng/sensor-humidity.png';
import LightPng from 'commons/src/img/sensorIcons/sensorPng/sensor-light.png';
import MoldPng from 'commons/src/img/sensorIcons/sensorPng/sensor-mold.png';
import NoisePng from 'commons/src/img/sensorIcons/sensorPng/sensor-noise.png';
import PMPng from 'commons/src/img/sensorIcons/sensorPng/sensor-pm.png';
import RadonPng from 'commons/src/img/sensorIcons/sensorPng/sensor-radon.png';
import TempPng from 'commons/src/img/sensorIcons/sensorPng/sensor-temp.png';
import VentilationPng from 'commons/src/img/sensorIcons/sensorPng/sensor-ventilation.png';
import VirusRiskPng from 'commons/src/img/sensorIcons/sensorPng/sensor-virus.png';
import VocPng from 'commons/src/img/sensorIcons/sensorPng/sensor-voc.png';
import { SensorTypes, Rating } from 'commons/src/models/commonEnums';
import { ThresholdRange } from 'commons/src/models/commonTypeScript';
import { statusColor } from 'commons/src/sensorRatingUtils';

export type SpaceMeasurementData = {
    average?: number;
    highestMeasurement?: number;
    lowestMeasurement?: number;
    name: string;
    roomType: string;
    serialNumber: string;
    floor?: number;
};

export type SpaceMeasurementDataColumns = SpaceMeasurementData[];

export const getSensorIconSource = (sensorType: string): string | null => {
    const normalizedSensorType = sensorType.toLowerCase().replace(/[.\s]/g, '');
    const sensorTypeToIconPathMap: { [sensorType: string]: string } = {
        humidity: HumidityPng,
        voc: VocPng,
        co2: Co2Png,
        temp: TempPng,
        virusRisk: VirusRiskPng,
        radonshorttermavg: RadonPng,
        radonshortterm: RadonPng,
        pm25: PMPng,
        pm1: PMPng,
        pm10: PMPng,
        noise: NoisePng,
        light: LightPng,
        mold: MoldPng,
        ventilationrate: VentilationPng,
    };
    return sensorTypeToIconPathMap[normalizedSensorType] || null;
};

export const formatSensorUnit = (sensorType: string, measurementUnit: keyof typeof sensorUnits): string => {
    const upperCaseMeasurementUnit = measurementUnit.toString().toUpperCase();
    return sensorType === SensorTypes.temp
        ? `${sensorUnits[measurementUnit]}${upperCaseMeasurementUnit}`
        : sensorUnits[measurementUnit];
};

export const formatSensorValue = (
    measurementValue: number | undefined,
    measurementUnit: keyof typeof sensorUnits
): string => {
    if (measurementValue === undefined || measurementValue === null || Number.isNaN(measurementValue)) {
        return 'N/A';
    }
    return sensorUnits[measurementUnit] === sensorUnits.pci ? measurementValue.toFixed(1) : measurementValue.toFixed(0);
};

export const getStatusColor = (thresholdRanges: ThresholdRange[], measurementValue: number | undefined): string => {
    return statusColor(thresholdRanges, measurementValue);
};

export const getStatusPillColors = (rating: Rating | undefined): { backgroundColor: string; textColor: string } => {
    if (rating === Rating.POOR) {
        return {
            backgroundColor: '#FBEBED',
            textColor: '#B72733',
        };
    }
    if (rating === Rating.FAIR) {
        return {
            backgroundColor: '#FEF7E1',
            textColor: '#B8860B',
        };
    }
    return {
        backgroundColor: '#EAF7EE',
        textColor: '#2D7C4C',
    };
};

export const sanitizeFileName = (unsanitizedFileName: string): string => {
    if (!unsanitizedFileName) return '';
    return unsanitizedFileName
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[^a-zA-Z0-9._-]/g, '_')
        .replace(/_{2,}/g, '_')
        .replace(/^_+|_+$/g, '')
        .replace(/^\.+|\.+$/g, '');
};
